export default class IntroSteps {
    constructor($rootScope, $window, $filter, $q) {
        this._rootScope = $rootScope;
        this._window = $window;
        this._filter = $filter;
        this._q = $q;
        this.steps = [];

        this._window.onload = () => {
            this.setSteps();
            this._rootScope.$broadcast('steps:loaded');
        };

        this._rootScope.$on('intro:language:selected', (event) => {
            this.setSteps();
        });
    }

    getSteps(state) {
        var deferred = this._q.defer();
        this.state = state;
        var parsedState = this.parseState(state);
        var resultSteps = this.steps[parsedState] ? this.steps[parsedState] : [];
        deferred.resolve(resultSteps);

        return deferred.promise;
    };

    addStep(step) {
        if (this.state == 'dashboard.index') {
            var parsedState = this.parseState(this.state);
            this.steps[parsedState].push(step);
        }
    };

    parseState(state) {
        return state.split('.')[0];
    }

    setSteps() {
        this.steps.dashboard = [
            {
                element: document.querySelector('#introStarter'),
                intro: this._filter('translate')('INTRO:DASHBOARD:WELCOME'),
                position: 'left'
            },
            {
                element: document.querySelector('#rowmenu'),
                intro: this._filter('translate')('INTRO:DASHBOARD:ROW_MENU'),
                position: 'bottom'
            },
            {
                element: document.querySelector('.dropdownmenu'),
                intro: this._filter('translate')('INTRO:DASHBOARD:DROPDOWN_MENU'),
                position: 'right'
            },
            {
                element: $("#hs-beacon").find('iframe')[0],
                intro: this._filter('translate')('INTRO:DASHBOARD:BUOY'),
                position: 'left'
            }
        ];
    };
};

// IntroSteps.$inject = ['$rootScope', '$window', '$filter', '$q'];
